import { jsx as i } from "react/jsx-runtime";
import y, { useState as C, useRef as J, createElement as K, Fragment as L, useEffect as f } from "react";
import N, { css as U } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as W } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { D as s, a as X } from "./index-2be68378.mjs";
import { TextInput as g } from "./textInput.js";
import { u as Y } from "./uniqueId-321287e8.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./icon.js";
import "@fcamna/shared-icons";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./helperText-d9646f54.mjs";
import "./menu.js";
import "./radio.js";
const T = N.div`
  ${({
  theme: {
    components: { dropdownMenu: n }
  }
}) => U(n.Control)};
`, Z = (n, l) => {
  let p = n.trim();
  return p = p.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), l.filter((o) => `${o.label}${o.value}`.search(new RegExp(p, "i")) >= 0).map((o) => o.value);
}, h = ({ ...n }) => /* @__PURE__ */ i(X, { ...n }), d = ({
  children: n,
  uniqueIdentifier: l,
  onChange: p,
  type: o = "default",
  searchHandler: O = null,
  menuHeader: M = "default",
  isDisabled: E = !1,
  menuDirection: R = "down_left",
  searchValue: u = "",
  closeOnSelect: k = !1,
  menuToggleSubscriber: S,
  loadDefaultOptions: _ = 0,
  onBlur: B,
  maxItems: j = 8,
  className: A,
  exceedOverflow: F = !1,
  accessibilityOptions: P = {}
}) => {
  const Q = W({ label: "Dropdown Menu" }), [m, $] = C(!1), [c, a] = C(""), [D, b] = C([]), [q, z] = C([]), v = J(Y("dd")), I = [];
  let x = !1;
  const G = y.Children.map(n, (t, r) => {
    if (t && y.isValidElement(t)) {
      if (t.type === h) {
        const e = t.props;
        return I.push({
          value: e.value,
          label: e.label,
          description: e.description,
          key: e.value
        }), /* @__PURE__ */ i(
          s.Item,
          {
            ...e,
            isSelected: D.length > 0 ? D.map((w) => w.value).includes(e == null ? void 0 : e.value) : (e == null ? void 0 : e.isSelected) || !1
          },
          r
        );
      } else if (t.type === T) {
        const e = t.props;
        return e != null && e.render ? /* @__PURE__ */ i(s.Control, { children: e == null ? void 0 : e.render({
          id: `control-${l || v.current}`,
          ariaControls: `list-${l || v.current}`,
          ariaHasPopup: "listbox",
          ariaExpanded: m,
          ariaActivedescendant: ""
        }) }, r) : /* @__PURE__ */ K(
          s.Control,
          {
            ...e,
            key: r
          }
        );
      } else if (t.type === g) {
        const e = t.props;
        return x = !0, /* @__PURE__ */ i(s.Control, { children: /* @__PURE__ */ i(
          g,
          {
            ...e,
            id: `control-${l || v.current}`,
            value: c,
            onChange: (w) => {
              w.stopPropagation(), m || $(!0), a(w.target.value);
            }
          }
        ) }, r);
      } else if (c.trim().length === 0)
        return /* @__PURE__ */ i(L, { children: t }, r);
    }
  });
  f(() => {
    var t;
    S && S(m), a(m || o === "multiple" ? "" : ((t = D[0]) == null ? void 0 : t.label) || "");
  }, [m]), f(() => {
    u && a(u);
  }, [u]), f(() => {
    a(u);
  }, [u]), f(() => {
    let t = [];
    O ? t = O(c, I) : t = Z(c, I), z(I.filter((r) => !t.includes(r.value)).map((r) => r.value));
  }, [c]), f(() => {
    _ < 0 && $(!0), b([]);
  }, [_]);
  const H = (t, r) => {
    t.stopPropagation(), p == null || p(t, r), b(o === "multiple" ? r : [r]);
  };
  return /* @__PURE__ */ i(
    s,
    {
      exceedOverflow: F,
      className: A,
      menuOpen: m,
      handleMenuOpen: (t) => $(t),
      isDisabled: E,
      menuDirection: R,
      maxItems: j,
      uniqueIdentifier: l || v.current,
      type: o,
      closeOnSelect: k,
      onBlur: B,
      onChange: H,
      hiddenItems: q,
      accessibilityOptions: P,
      menuHeader: M && M !== "local_search" ? M : x && "default" || "local_search",
      ...Q,
      children: G
    }
  );
};
d.Control = T;
d.ControlInput = g;
d.Item = h;
d.Divider = s.Divider;
d.Title = s.Title;
export {
  d as DropdownMenu
};
